import t, { useLayoutEffect as n, useEffect as c } from "react";
const s = typeof window < "u" ? n : c, m = process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== "test" ? ({ children: e }) => e : ({ brand: e, children: o }) => (s(() => {
  document.documentElement.setAttribute("data-theme", e || "");
}, [e]), /* @__PURE__ */ t.createElement(t.Fragment, null, o));
export {
  m as Theme
};
